
    const data = {"name":"src/core/icons/clipboard-check-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2m.5 6.5L9 12l2 2 4.5-4.5L17 11l-6 6-3.5-3.5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            